<template>
  <el-tag :type="tagType">{{ label }}</el-tag>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  options: { type: Array, default: () => [] },
  value: [String, Number]
})

const label = computed(() => {
  const item = props.options.find(o => String(o.value) === String(props.value))
  return item ? item.label : props.value
})

const tagType = computed(() => {
  const item = props.options.find(o => String(o.value) === String(props.value))
  return item ? (item.elTagType || '') : ''
})
</script>
